import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export default function PriceOnRequestBanner({ t, onNavigate }) {
    return (
        <section className="border-t border-white/5 px-5 sm:px-8 py-24 sm:py-28">
            <motion.div
                data-testid="price-on-request-banner"
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, ease: EASE }}
                className="relative mx-auto max-w-5xl overflow-hidden rounded-lg border border-glacier/25 bg-coal px-8 py-12 sm:px-14 sm:py-16"
            >
                <div className="pointer-events-none absolute -right-5 -top-5 h-20 w-20 border border-glacier/20 animate-floaty-slow" />
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
                    <div className="max-w-2xl">
                        <p className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-glacier">
                            <span className="inline-block h-px w-10 bg-glacier/60" />
                            {t.price.overline}
                        </p>
                        <h2 className="mt-5 font-display text-3xl sm:text-4xl font-medium tracking-tight">
                            {t.price.title}
                        </h2>
                        <p className="mt-5 text-base leading-relaxed text-fog">{t.price.text}</p>
                        <ul className="mt-7 space-y-3">
                            {t.price.points.map((point) => (
                                <li key={point} className="flex items-center gap-3 text-sm text-ivory/90">
                                    <Check size={14} strokeWidth={2.5} className="text-glacier" />
                                    {point}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <button
                        data-testid="price-banner-cta-button"
                        onClick={() => onNavigate("#kontakt")}
                        className="group inline-flex shrink-0 items-center gap-3 rounded-sm bg-glacier btn-shine px-8 py-4 font-display text-sm font-semibold uppercase tracking-widest text-ink transition-colors duration-300 hover:bg-ivory hover:shadow-[0_0_28px_rgba(74,222,128,0.3)]"
                    >
                        {t.price.cta}
                        <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                    </button>
                </div>
            </motion.div>
        </section>
    );
}
